 // For full API documentation, including code examples, visit http://wix.to/94BuAAs
 import { calc } from 'backend/calculate';

 $w.onReady(function () {
 	//TODO: write your page related code here...

 });

 export function calcBtn_click(event) {
 	var length = 0;
 	var width = 0;
 	var area = 0;
 	var volume = 0;
 	var kw = 0;
 	if ($w("#input1").value > 0) {
 		length = parseFloat($w("#input1").value);
 	}
 	if ($w("#input2").value > 0) {
 		width = parseFloat($w("#input2").value);
 	}
 	if ($w("#input3").value > 0) {
 		area = parseFloat($w("#input3").value);
 	}
 	if ($w("#input4").value > 0) {
 		volume = parseFloat($w("#input4").value);
 	}
 	calc(length, width, area, volume, $w("#dropdown1").value, $w("#dropdown2").value, $w("#dropdown3").value, $w("#dropdown4").value).then(result => {
 			$w("#text117").text = 'kW : ' + result.kw.toFixed(2).toString();
 			$w("#text118").show();
 			$w("#text117").show();
 		})
 		.catch(error => {
 			console.log(error);
 		});
 }

 export function length_click(event) {
 	//Add your code for this event here: 
 	$w("#input4").disable();
 	$w("#input3").disable();
 	$w("#input2").enable();
 	$w("#input1").enable();
 }

 export function width_click(event) {
 	$w("#input4").disable();
 	$w("#input3").disable();
 	$w("#input2").enable();
 	$w("#input1").enable();
 }

 export function area_click(event) {
 	$w("#input1").disable();
 	$w("#input2").disable();
 	$w("#input3").enable();
 	$w("#input4").disable();
 }

 export function volume_click(event) {
 	$w("#input1").disable();
 	$w("#input2").disable();
 	$w("#input4").enable();
 	$w("#input3").disable();
 }

 export function reset_click(event) {
 	$w("#input1").enable();
 	$w("#input2").enable();
 	$w("#input4").enable();
 	$w("#input3").enable();
 	$w("#input1").value = null;
 	$w("#input1").resetValidityIndication();
 	$w("#input2").value = null;
 	$w("#input2").resetValidityIndication();
 	$w("#input3").value = null;
 	$w("#input3").resetValidityIndication();
 	$w("#input4").value = null;
 	$w("#input4").resetValidityIndication();
 	$w("#dropdown1").selectedIndex = 4;
 	$w("#dropdown2").selectedIndex = 10;
 	$w("#dropdown3").selectedIndex = 5;
 	$w("#dropdown4").selectedIndex = 0;
 	$w("#dropdown4").selectedIndex = 0;
 }
 export function HRB_change(event) {
 	if ($w("#dropdown4").value === "1") {

 		$w('#dropdown2').selectedIndex = 5;
 	}
 }